import { localized } from "@msuite/ui/localization";
import {
	createColumnHelper,
	createMeta,
	createRowActions,
	createSubRowHandle,
} from "@msuite/ui/table";
import { OrderStateTag } from "@msuite/ui/tag";
import { updatedAtFormatter } from "@msuite/utils/date";
import { getOrderStateTranslationKey, getSuborderNumberString } from "@msuite/utils/stock";
import { guardString } from "@msuite/utils/strings";
import type { SuborderListItem } from "@msuite/utils/types";
import { columns as quantityTableColumns } from "../quantity-table-config";
import { RowActions } from "./row-actions";
import { SuborderAction } from "./suborder-action";

const columnHelper = createColumnHelper<SuborderListItem>();

export const columns = [
	createSubRowHandle<SuborderListItem>(),
	columnHelper.accessor(
		(row) => getSuborderNumberString({ orderNumber: row.orderNumber, suborderNumber: row.number }),
		{
			id: "suborderNumber",
			header: localized("general.number"),
			cell: (cell) => cell.getValue(),
			meta: createMeta({
				isTabular: true,
			}),
		},
	),
	columnHelper.accessor("warehouseZoneName", {
		id: "warehouseZoneName",
		header: localized("stock.warehouse_zone"),
		cell: (cell) => cell.getValue(),
	}),
	columnHelper.accessor((row) => localized(getOrderStateTranslationKey(row.state)), {
		id: "state",
		header: localized("general.state"),
		cell: (cell) => <OrderStateTag state={cell.row.original.state} />,
	}),
	columnHelper.accessor(updatedAtFormatter, {
		id: "updatedAt",
		header: localized("general_fields.updated_at"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	columnHelper.accessor("updatedByName", {
		id: "updatedByName",
		header: localized("general_fields.updated_by"),
		cell: (cell) => guardString(cell.getValue()),
	}),
	...quantityTableColumns,
	// The manager's release/recall control is the last data column, directly before the row
	// actions: this order is what the column menu lists and what an unpinned layout renders,
	// and `SubordersTable` pins the column to the end so it stays there when the table scrolls.
	columnHelper.display({
		id: "action",
		header: localized("tables.actions"),
		cell: (cell) => <SuborderAction item={cell.row.original} />,
		size: 250,
	}),
	createRowActions(RowActions),
];
